<script setup lang="ts">
import { loaderTheme } from './theme';
import type { ULoaderProps } from './types';

const props = withDefaults(defineProps<ULoaderProps>(), {
  size: 'sm',
});

const ui = loaderTheme({ size: props.size });
</script>

<template>
  <div :class="ui.root({ class: props.ui?.root })">
    <div :class="ui.spinner({ class: props.ui?.spinner })" />
  </div>
</template>
